/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgOilAndGas = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M9 4a2 2 0 0 1 2 2H9.323l-.252.629-6 15-.148.371h2.964L12 18.18 18.113 22h2.964l-.149-.371-6-15L14.677 6H13a2 2 0 0 1 2-2V2a3.99 3.99 0 0 0-3 1.354A3.99 3.99 0 0 0 9 2v2zm8.935 15.53L13.887 17l2.429-1.518 1.619 4.048zM12 15.82l-3.561-2.225.238-.595h6.646l.238.595L12 15.821zM13.323 8l1.2 3H9.477l1.2-3h2.646zm-3.21 9-4.048 2.53 1.62-4.048L10.112 17z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgOilAndGas as OilAndGas };
